import angular from 'angular';

import DefaultGrouping from './default';

class TagsGrouping extends DefaultGrouping {
  constructor($rootScope) {
    super();

    this.currentCase = $rootScope.currentCase;

    this.displayName = 'Tags';
    this.key = 'tags';
    this.ungroupedName = 'No Tags';

    this.columnsByGroup = super.setColumns([
      'factDateish',
      'title',
      'content',
      'sources',
      'legalIssues',
      this.key,
      'contributors',
      'creationDate'
    ]);

    this.getDocDisplayText = this.getDisplayText;
    this.getSortingValue = this.getMemoText;
    this.getHeaderDisplayName = super.getDisplayName;
  }

  getDocDisplayStyles() {
    var result = DefaultGrouping.getDocDisplayStyles();
    result['width'] = '16%';
    return result;
  };

  getFactItems(tags, branchId) {
    return tags.filter(tag => tag.id !== branchId).map(tag => tag.displayName);
  };

  getDisplayText(tags, branchId) {
    return this.getFactItems(tags, branchId).join(',<br />');
  };

  getMemoText(tags, branchId) {
    return this.getFactItems(tags, branchId).join(', ');
  };

  getItemsByFact(fact) {
    var items = fact[this.key].map(function (item) {
      return item;
    });
    return items.length > 0 ? items : ['ungrouped'];
  };


}
TagsGrouping.$inject = ['$rootScope'];

export default angular.module('groupings.tags-grouping', [])
  .service('TagsGrouping', TagsGrouping)
  .name;



// WEBPACK FOOTER //
// ./project/groupings/tags.js